<template>
  <el-row>
    <el-row class="BannerContWidth">
      <el-col :span="24">
        <el-col :span="16"
                :xs='24'>
          <div class="DetailsCont">
            <img v-if="Article.title_url"
                 class="gametitleimg"
                 :src="Article.title_url">
            <div class="ArticleTitle">{{Article.title}}</div>
            <div class="ArticleCont"
                 v-html="Article.content">
            </div>
          </div>
        </el-col>
        <el-col :md="{span: 7,offset: 1}"
                :sm="{span: 8,offset: 0}"
                class="hidden-xs-only">
          <QRCode></QRCode>
        </el-col>
      </el-col>
    </el-row>
    <foot></foot>
  </el-row>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
import QRCode from '@/components/QRCode'
import foot from '@/components/foot'
export default {
  name: 'ArticleDetails',
  components: {
    QRCode,
    foot
  },
  data () {
    return {
      Article: ''
    }
  },
  created () {

    this.ArticleDetailsData()
  },
  methods: {
    ArticleDetailsData () {
      let url
      if (this.$route.query.Cla) {
        url = this.apiUrl.API.GetBannerDetail
      } else {
        url = this.apiUrl.API.GetContentDetail
      }
      // 文章内容中的图片需要在前边加上ip端口
      // http://47.240.11.130:8899/lumiManager/plugins/ueditor/jsp/upload1/20200424/60931587697538236.jpg
      this.$axios.get(url, {
        params: {
          announcementId: this.$route.query.id
        }
      })
        .then((res) => {
          this.Article = res.data.data
        })
    }
  },
  updated () {
    document.querySelectorAll('.ArticleCont img').forEach(element => {
      if (element.src.indexOf('lumiManager')) {
        element.style = 'max-width: 100%;'
      }
    });
  }
}
</script>

<style scoped>
.BannerContWidth {
  width: 1040px;
  display: flex;
  margin: 0 auto;
}
.DetailsCont {
  /* width: 100%; */
  margin: 1.5rem 0;
  background: #fff;
  border-radius: 3px;
  padding: 20px 30px;
  text-align: justify;
  word-break: break-word;
  white-space: pre-wrap;
}
.DetailsCont > .gametitleimg {
  width: 100%;
}
.ArticleTitle {
  font-size: 2rem;
  margin: 30px 0 30px 0;
}
.ArticleCont {
  text-align: justify;
  word-break: break-word;
  white-space: pre-wrap;
  line-height: 1.7rem;
}
@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetails.vue